var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{class:_vm.className,attrs:{"rotate":-90,"size":33,"width":2,"value":_vm.question_completion_percentage,"color":_vm.progressColour}},[_vm._v(" "+_vm._s(_vm.question_completion_percentage)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }